import { render } from "./DealsList.vue?vue&type=template&id=36a9d6ca&scoped=true&ts=true"
import script from "./DealsList.vue?vue&type=script&lang=ts"
export * from "./DealsList.vue?vue&type=script&lang=ts"

import "./DealsList.vue?vue&type=style&index=0&id=36a9d6ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a9d6ca"]])

export default __exports__